/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu, Jul 22nd 2021, 8:50:42 am
 *
 * *****************************************************
 */

import { MouseEvent } from 'react';

import { ReactComponent as ArrowRightIcon } from 'assets/images/arrowRight.svg';

import { Container, WorkspaceAvatar } from './styles';

type Props = {
  name: string;
  color: string;
  id: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

/**
 * Workspace item in select workspace page
 */
const WorkspaceItem = ({ name, color = '#000', id, onClick }: Props): JSX.Element => {
  const avatarName = name ? name.slice(0, 1).toLocaleUpperCase() : '';
  return (
    <Container>
      <button type="button" className="Polaris-Button" data-id={id} onClick={onClick}>
        <WorkspaceAvatar color={color}>{avatarName}</WorkspaceAvatar>
        <span>{name}</span>
        <ArrowRightIcon />
      </button>
    </Container>
  );
};

export default WorkspaceItem;
